export default __webpack_public_path__ + "static/media/dragon.ac81a2e4.png";